import { createAction } from "@reduxjs/toolkit";

export const isAddUserDialogOpenAction = createAction('isAddUserDialogOpen', function prepare(isOpen: boolean) {
    return {
        payload: {
            isOpen
        },
    }
});
